import React from 'react';
import {FormBlock, FormBlockFieldStandard} from 'api';
import NameField from './Name';
import EmailField from './Email';
import AccountNameField from './AccountName';
import SectionField from './Section';
import SectionPositionField from './SectionPosition';
import AccountTelephoneNumberField from './AccountTelephoneNumber';
import TelephoneNumberField from './TelephoneNumber';
import AddressField from './Address';
import WebSiteField from './WebSite';

interface Block extends FormBlock {
  formBlockable: FormBlockFieldStandard;
}

interface Props {
  block: Block;
}

const standardFieldComponents: {[key: string]: any} = {
  name: NameField,
  email: EmailField,
  account_name: AccountNameField,
  section: SectionField,
  section_position: SectionPositionField,
  account_telephone_number: AccountTelephoneNumberField,
  telephone_number: TelephoneNumberField,
  address: AddressField,
  web_site: WebSiteField,
};

export default ({block}: Props) => {
  const blockable = block.formBlockable;
  const FieldComponent = standardFieldComponents[blockable.standardFieldType];

  if (!FieldComponent) return null;

  return <FieldComponent block={block} />;
};
